import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import './assets/main.css'
import {Toaster as VueToaster} from 'vue-sonner'
import {createPinia} from 'pinia'
import SweetAlert from './plugins/sweetalert'
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'


/**
 * Create Pinia instance
 */
const pinia = createPinia()

/**
 * Create the Vue application instance
 */
const app = createApp(App)

// Register plugins
app.use(pinia)
app.use(mavonEditor)
app.use(SweetAlert)
app.use(router)

// Register global components
app.component('VueToaster', VueToaster)

// Mount the application
app.mount('#app')